// extracted by mini-css-extract-plugin
module.exports = {"rollingMessage":"_1fc_P","globalAlert":"_3fGa5"};